import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/auth/LoginPage";

import AdminDashboard from "./pages/admin/AdminDashboard";
import StaffPage from "./pages/admin/StaffPage";
import AttendancePage from "./pages/admin/AttendancePage";
import DocumentsPage from "./pages/admin/DocumentsPage";
import TimesheetsPage from "./pages/admin/TimesheetsPage";

import StaffDashboard from "./pages/staff/StaffDashboard";

import PortalProtectedRoute from "./components/PortalProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* root redirect */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* login */}
        <Route path="/login" element={<LoginPage />} />

        {/* ---------------- ADMIN ROUTES ---------------- */}
        <Route
          path="/admin"
          element={
            <PortalProtectedRoute type="admin">
              <AdminDashboard />
            </PortalProtectedRoute>
          }
        />

        <Route
          path="/admin/staff"
          element={
            <PortalProtectedRoute type="admin">
              <StaffPage />
            </PortalProtectedRoute>
          }
        />

        <Route
          path="/admin/attendance"
          element={
            <PortalProtectedRoute type="admin">
              <AttendancePage />
            </PortalProtectedRoute>
          }
        />

        <Route
          path="/admin/documents"
          element={
            <PortalProtectedRoute type="admin">
              <DocumentsPage />
            </PortalProtectedRoute>
          }
        />

        <Route
          path="/admin/timesheets"
          element={
            <PortalProtectedRoute type="admin">
              <TimesheetsPage />
            </PortalProtectedRoute>
          }
        />

        {/* ---------------- STAFF ROUTES ---------------- */}
        <Route
          path="/staff"
          element={
            <PortalProtectedRoute type="staff">
              <StaffDashboard />
            </PortalProtectedRoute>
          }
        />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}